var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.33203 8.50004H14.6654M1.33203 8.50004C1.33203 12.1819 4.3168 15.1667 7.9987 15.1667M1.33203 8.50004C1.33203 4.81814 4.3168 1.83337 7.9987 1.83337M14.6654 8.50004C14.6654 12.1819 11.6806 15.1667 7.9987 15.1667M14.6654 8.50004C14.6654 4.81814 11.6806 1.83337 7.9987 1.83337M7.9987 1.83337C9.66622 3.65894 10.6139 6.02806 10.6654 8.50004C10.6139 10.972 9.66622 13.3411 7.9987 15.1667M7.9987 1.83337C6.33118 3.65894 5.38353 6.02806 5.33203 8.50004C5.38353 10.972 6.33118 13.3411 7.9987 15.1667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01);
export default __webpack_public_path__ + "static/media/globe-01.9652d4860bc6701c9dc5a8daf43ef97d.svg";
export { ForwardRef as ReactComponent };